$(document).ready(function() {

// fancybox for mp4 videos
    $(".vid_mp4").fancybox({
        type: 'iframe',
    });
});